import { EMovingType } from '../../constants/pikPlus';

export function getMovingType(type?: string | null) {
  if (type) {
    if (/пешком/gi.test(type)) {
      return EMovingType.Walk;
    }

    if (/транспорт|авто/gi.test(type)) {
      return EMovingType.Transport;
    }
  }

  return null;
}
